export const LINE_ITEM_PRICE_MODEL = {
  PER_CATEGORY: 'PER_CATEGORY',
  RECURRING: 'RECURRING',
  NON_RECURRING: 'NON_RECURRING',
};

export const LINE_ITEM_PRICE_MODEL_LIST = Object.values(LINE_ITEM_PRICE_MODEL);
